import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {RestService} from "../immerdrin/rest.service.interface";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {LoggerService} from "../../shared/logger.service";
import {AuthService} from "../../shared/auth.service";
import {InsertEditMitDialogs} from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http"; import {FormsModule} from "@angular/forms";

const PATH_FILE = 'app/protected/kernnavigation/kernnavigation.insertEdit.component.ts';
const OBJ_LNG_NAME = 'navigation';

@Component({
    selector: 'oase-kernnavigation-insertEdit.dialog',
    templateUrl: './kernnavigation.insertEdit.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class KernnavigationInsertEditComponent extends InsertEditMitDialogs {

    aktuellurlmax = null;
    zieltypen: string[] = [];
    ladedaten: boolean = false;
    public OBJ_LNG_NAME: string;

    constructor(
        public dialogRef: MatDialogRef<KernnavigationInsertEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
        public dialog: MatDialog,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public _logger: LoggerService) {
            super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);
            this.OBJ_LNG_NAME=OBJ_LNG_NAME;
    }

    // such comparison is needed for mat-select
    compareMitId(item1, item2) {
        return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }

    specificInitHandling(aktuell: any) {
        aktuell.zieltypen =  ['_self', '_blank'];
        aktuell.tempSprachSchluessel = aktuell.sprachschluessel != null ? aktuell.sprachschluessel.replace(/^menue./, '') : "";
		this.changeAktuelleUrl();
        this._logger.debug(this.aktuellurlmax);
    }

    specificPreSaveHandling(aktuell: any) {
        aktuell.sprachschluessel = "menue."+aktuell.tempSprachSchluessel;
        aktuell.recht.sprachschluessel = 'recht.' + aktuell.sprachschluessel;

        aktuell.icon = aktuell.icon != null && aktuell.icon == '' ? null : aktuell.icon;
        aktuell.url = aktuell.url != null && aktuell.url == '' ? null : aktuell.url;
        aktuell.urlschema = aktuell.urlschema != null && aktuell.urlschema == '' ? null : aktuell.urlschema;
        aktuell.host = aktuell.host != null && aktuell.host == '' ? null : aktuell.host;
        aktuell.pfad = aktuell.pfad != null && aktuell.pfad == '' ? null : aktuell.pfad;
        aktuell.query = aktuell.query != null && aktuell.query == '' ? null : aktuell.query;
        aktuell.fragment = aktuell.fragment != null && aktuell.fragment == '' ? null : aktuell.fragment;
    }

    private fuelleUrl() {
        this.aktuell.icon = this.aktuell.icon ?? '';
        this.aktuell.url = this.aktuell.url ?? '';
        this.aktuell.urlschema = this.aktuell.urlschema ?? '';
        this.aktuell.host = this.aktuell.host ?? '';
        this.aktuell.pfad = this.aktuell.pfad ?? '';
        this.aktuell.query = this.aktuell.query ?? '';
        this.aktuell.fragment = this.aktuell.fragment ?? '';
    }

    changeAktuelleUrl(): void {
        let url = '';
        if(this.aktuell.urlschema != null && this.aktuell.urlschema != '')
            url += this.aktuell.urlschema + '://';
        if(this.aktuell.host != null && this.aktuell.host != '')
            url += this.aktuell.host;
        if(this.aktuell.pfad != null && this.aktuell.pfad != '')
            url += '/' + this.aktuell.pfad;
        if(this.aktuell.query != null && this.aktuell.query != '')
            url += '?' + this.aktuell.query;
        if(this.aktuell.fragment != null && this.aktuell.fragment != '')
            url += '#' + this.aktuell.fragment;

        if(this.aktuell.url != url) {
            this.aktuell.url = url;
            this.aktuell.aktuellurlmax.urlschema = 255 - this.aktuell.url.length + (this.aktuell.urlschema != null ? this.aktuell.urlschema.length : 0);
            this.aktuell.aktuellurlmax.host = 255 - this.aktuell.url.length + (this.aktuell.host != null ? this.aktuell.host.length : 0);
            this.aktuell.aktuellurlmax.pfad = 255 - this.aktuell.url.length + (this.aktuell.pfad != null ? this.aktuell.pfad.length : 0);
            this.aktuell.aktuellurlmax.query = 255 - this.aktuell.url.length + (this.aktuell.query != null ? this.aktuell.query.length : 0);
            this.aktuell.aktuellurlmax.fragment = 255 - this.aktuell.url.length + (this.aktuell.fragment != null ? this.aktuell.fragment.length : 0);
        }
    }

    createRange(number){
        let items: number[] = [];
        for(let i = 1; i <= number; i++)
            items.push(i);
        return items;
    }

    holeMaxReihenfolge(): number {
        if(!this.neu) {
            if(this.aktuell.vater == null && this.aktuell.vaterOrig == null ||
                this.aktuell.vater != null && this.aktuell.vaterOrig != null && this.aktuell.vater.id == this.aktuell.vaterOrig.id)
                return this.aktuell.maxReihenfolge;
        }

        let maxReihenfolge: number = 1;

        if(this.aktuell.vater == null) {
            for(const currentParent of this.aktuell.eltern) {
                maxReihenfolge += currentParent.vater == null ? 1 : 0;
            }
        } else {
            for(const currentParent of this.aktuell.eltern) {
                maxReihenfolge += currentParent.vater != null && currentParent.vater.id == this.aktuell.vater.id ? 1 : 0;
            }
        }
        return maxReihenfolge;
    }
}